import { styled } from 'styled-components'

export const Container = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  height: ${({ open }) => (open ? '100%' : '0')};
  left: 0;
  opacity: ${({ open }) => (open ? 1 : 0)};
  position: fixed;
  right: 0;
  top: 0;
  width: ${({ open }) => (open ? '100%' : '0')};
  z-index: ${({ open }) => (open ? 10 : -1)};
`
